/* eslint-disable react/display-name */
import React, { useState } from 'react'
import { Container, Badge, Row, Card, Modal } from 'reactstrap'
import Header from '../components/Headers/Header'
import AddonComponent from '../components/Addon/Addon'
import { getRestaurantDetail, deleteAddon } from '../apollo/server'
import CustomLoader from '../components/Loader/CustomLoader'
import DataTable from 'react-data-table-component'
import orderBy from 'lodash/orderBy'
import { withTranslation } from 'react-i18next'
import gql from 'graphql-tag'
import { Query, Mutation, compose, withApollo } from 'react-apollo'
import Loader from 'react-loader-spinner'
import { handleErrors } from '../utils/handleErrors'

const GET_ADDONS = gql`
  ${getRestaurantDetail}
`
const DELETE_ADDON = gql`
  ${deleteAddon}
`

const Addon = props => {
  const [addon, setAddon] = useState(null)
  const [editModal, setEditModal] = useState(false)

  const toggleModal = addon => {
    setEditModal(!editModal)
    setAddon(addon)
  }

  const restaurantId = localStorage.getItem('restaurant_id')

  const customSort = (rows, field, direction) => {
    const handleField = row => {
      if (row[field] && isNaN(row[field])) {
        return row[field].toLowerCase()
      }

      return row[field]
    }

    return orderBy(rows, handleField, direction)
  }

  const handleSort = (column, sortDirection) =>
    console.log(column.selector, sortDirection)

  const columns = [
    {
      name: 'Title',
      sortable: true,
      selector: 'title'
    },
    {
      name: 'Description',
      sortable: true,
      selector: 'description'
    },
    {
      name: 'Minimum',
      sortable: true,
      selector: 'quantityMinimum'
    },
    {
      name: 'Maximum',
      sortable: true,
      selector: 'quantityMaximum'
    },
    {
      name: 'Action',
      cell: row => <>{actionButtons(row)}</>
    }
  ]
  const actionButtons = row => {
    return (
      <>
        <Badge
          href="#pablo"
          onClick={e => {
            e.preventDefault()
            toggleModal(row)
          }}
          color="primary">
          Edit
        </Badge>
        &nbsp;&nbsp;
        <Mutation
          mutation={DELETE_ADDON}
          refetchQueries={[
            { query: GET_ADDONS, variables: { id: restaurantId } }
          ]}>
          {(deleteAddon, { loading: deleteLoading }) => {
            if (deleteLoading) {
              return (
                <Loader
                  type="ThreeDots"
                  color="#BB2124"
                  height={20}
                  width={40}
                  visible={deleteLoading}
                />
              )
            }
            return (
              <Badge
                href="#pablo"
                color="danger"
                onClick={e => {
                  e.preventDefault()
                  deleteAddon({
                    variables: { id: row._id, restaurant: restaurantId }
                  })
                }}>
                {'Delete'}
              </Badge>
            )
          }}
        </Mutation>
      </>
    )
  }

  const { t } = props
  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <AddonComponent />
        <Row className="mt-5">
          <div className="col">
            <Card className="shadow">
              <Query query={GET_ADDONS} variables={{ id: restaurantId }}>
                {({ loading, error, data }) => {
                  if (error) {
                    const errorMsg = handleErrors(error.graphQLErrors)
                    return (
                      <tr>
                        <td>
                          {t('Error')}! {errorMsg}
                        </td>
                      </tr>
                    )
                  }
                  return (
                    <DataTable
                      title={t('Addons')}
                      columns={columns}
                      data={data.restaurant ? data.restaurant.addons : {}}
                      pagination
                      progressPending={loading}
                      progressComponent={<CustomLoader />}
                      onSort={handleSort}
                      sortFunction={customSort}
                      defaultSortField="title"
                    />
                  )
                }}
              </Query>
            </Card>
          </div>
        </Row>
        <Modal
          className="modal-dialog-centered"
          size="lg"
          isOpen={editModal}
          toggle={() => {
            toggleModal()
          }}>
          <AddonComponent addon={addon} />
        </Modal>
      </Container>
    </>
  )
}

export default compose(withApollo, withTranslation())(Addon)
